export enum SessionStorageKey {
  LatestPaxConfig = 'pax',
}
